import { cn } from '@/lib/utils';

interface JsonTextProps {
  /** Qualsevol valor serialitzable; es pinta amb `JSON.stringify(data, null, 2)`. */
  data: unknown;
  className?: string;
}

/**
 * Vista de depuració d'un objecte com a JSON, **sempre com a text**.
 *
 * Runbook 18, F4 (SEG-4): les dades que s'hi pinten venen d'hostes (formulari públic). Abans es
 * passaven per uns `replace` que hi posaven colors i es pintaven amb `dangerouslySetInnerHTML`:
 * una etiqueta escrita en un camp s'executava al navegador de qui obria «Detalls». Aquí React
 * escapa el text; no hi tornis a posar HTML.
 */
export function JsonText({ data, className }: JsonTextProps) {
  return (
    <pre className={cn('whitespace-pre-wrap break-words', className)}>
      {JSON.stringify(data, null, 2)}
    </pre>
  );
}
